export default {
    cityState: state => state.cities,
    districtState : state => state.district,
}
